export const locationOptions = {
  alabama: 'Alabama',
  alaska: 'Alaska',
  americanSamoa: 'American Samoa',
  arizona: 'Arizona',
  arkansas: 'Arkansas',
  california: 'California',
  colorado: 'Colorado',
  connecticut: 'Connecticut',
  delaware: 'Delaware',
  districtOfColumbia: 'District of Columbia',
  florida: 'Florida',
  georgia: 'Georgia',
  guam: 'Guam',
  hawaii: 'Hawaii',
  idaho: 'Idaho',
  illinois: 'Illinois',
  indiana: 'Indiana',
  iowa: 'Iowa',
  kansas: 'Kansas',
  kentucky: 'Kentucky',
  louisiana: 'Louisiana',
  maine: 'Maine',
  maryland: 'Maryland',
  massachusetts: 'Massachusetts',
  michigan: 'Michigan',
  minnesota: 'Minnesota',
  mississippi: 'Mississippi',
  missouri: 'Missouri',
  montana: 'Montana',
  nebraska: 'Nebraska',
  nevada: 'Nevada',
  newHampshire: 'New Hampshire',
  newJersey: 'New Jersey',
  newMexico: 'New Mexico',
  newYork: 'New York',
  northCarolina: 'North Carolina',
  northDakota: 'North Dakota',
  northernMarianaIslands: 'Northern Mariana Islands',
  ohio: 'Ohio',
  oklahoma: 'Oklahoma',
  oregon: 'Oregon',
  pennsylvania: 'Pennsylvania',
  puertoRico: 'Puerto Rico',
  rhodeIsland: 'Rhode Island',
  southCarolina: 'South Carolina',
  southDakota: 'South Dakota',
  tennessee: 'Tennessee',
  texas: 'Texas',
  utah: 'Utah',
  usVirginIslands: 'U.S. Virgin Islands',
  vermont: 'Vermont',
  virginia: 'Virginia',
  washington: 'Washington',
  westVirginia: 'West Virginia',
  wisconsin: 'Wisconsin',
  wyoming: 'Wyoming',
} as const

export const primarySoftwareOptions = {
  intuitProConnectTaxOnline: 'Intuit ProConnect Tax Online',
  intuitProSeriesTax: 'Intuit ProSeries Tax',
  intuitLacerteTax: 'Intuit - Lacerte Tax',
  woltersKluwerCCHAxcessTax: 'Wolters Kluwer - CCH Axcess Tax',
  cchProSystemsFX: 'CCH - Pro Systems FX',
  thomsonReutersGoSystemsTaxRS: 'Thomson Reuters - GoSystem Tax RS',
  thomsonReutersUltraTaxCS: 'Thomson Reuters - UltraTax CS',
  drakeSoftwareDrakeTax: 'Drake Software - Drake Tax',
  cchSfsAtx: 'CCH SFS - ATX',
  cchSfsTaxWise: 'CCH SFS - TaxWise',
  surePrep: 'SurePrep',
  workpaperCS: 'Workpaper CS',
  engagement: 'Engagement',
  caseware: 'Caseware',
  myTaxPrepOffice: 'My Tax Prep Office',
  taxActProfessional: 'TaxAct Professional',
  taxslayer: 'Taxslayer',
} as const

export const supplementalSoftwareOptions = {
  surePrep: 'SurePrep',
  caseware: 'Caseware',
  engagement: 'Engagement',
  workpaperCS: 'Workpaper CS',
} as const

export const specialtyOptions = {
  individual: 'Individual',
  farmingAgriculture: 'Farming/Agriculture (Sch F)',
  foreignNonResidents: 'Foreign (Non-residents)',
  passThroughEntities: 'Pass Through Entities',
  estatesTrusts: 'Estates/Trusts',
  nonProfits: 'Non-Profits',
  form1065: '1065',
  form1120: '1120',
  itin: 'ITIN',
  business: 'Business (1065/1120S/1120)',
  form1120S: '1120S',
  personalReviewer: 'Personal Reviewer',
  businessReviewer: 'Business Reviewer',
  taxDissolutionServices: 'Tax Dissolution Services',
  bookkeeping: 'Bookkeeping',
  crypto: 'Crypto',
  highNetWorthIndividuals: 'High Net Worth Individuals',
  cannabis: 'Cannabis',
} as const

export type LocationOption =
  (typeof locationOptions)[keyof typeof locationOptions]

export type PrimarySoftwareOption =
  (typeof primarySoftwareOptions)[keyof typeof primarySoftwareOptions]

export type SupplementalSoftwareOption =
  (typeof supplementalSoftwareOptions)[keyof typeof supplementalSoftwareOptions]

export type SpecialtyOption =
  (typeof specialtyOptions)[keyof typeof specialtyOptions]
